import React, { useState } from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false); // Zustand für das Hamburger-Menü

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="bg-teal-500 text-white shadow-md">
      <div className="container mx-auto px-6 py-4 flex justify-between items-center">
        {/* Logo */}
        <h1 className="text-2xl font-bold text-white">
          <Link to="/home">Fab Academy 2025</Link>
        </h1>

        {/* Hamburger Button für kleine Bildschirme */}
        <button
          onClick={toggleMenu}
          className="text-white focus:outline-none sm:hidden"
          aria-label="Toggle Menu"
        >
          <svg
            className="w-6 h-6"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>

        {/* Navigation für größere Bildschirme */}
        <div className="hidden sm:flex space-x-4">
          <Link to="/home" className="hover:text-gray-200">
            Home
          </Link>
          <Link to="/assignments" className="hover:text-gray-200">
            Assignments
          </Link>
          <Link to="/final-project" className="hover:text-gray-200">
            Final Project
          </Link>
          <Link to="/about" className="hover:text-gray-200">
            About Me
          </Link>
        </div>
      </div>

      {/* Dropdown-Menü für kleine Bildschirme */}
      <div
        className={`${
          isOpen ? "block" : "hidden"
        } sm:hidden bg-gray-400 text-white`}
      >
        <ul className="flex flex-col">
          <li>
            <Link to="/home" onClick={() => setIsOpen(false)}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/about" onClick={() => setIsOpen(false)}>
              About Me
            </Link>
          </li>
          <li>
            <Link to="/assignments" onClick={() => setIsOpen(false)}>
              Assignments
            </Link>
          </li>
          <li>
            <Link to="/final-project" onClick={() => setIsOpen(false)}>
              Final Project
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;

